// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header__line-1[data-v-13f01c14]{font-size:20px}.header__line-1__subtitle[data-v-13f01c14],.header__line-2[data-v-13f01c14]{font-size:12px}", ""]);
// Exports
module.exports = exports;
